<template>
    <div class="px-5 full-height">
        <div class="row py-5">
            <div class="col-12 d-flex justify-content-between">
                <div class="fs-giant" :class="{ 'opacity-50': isLoading || supplierTierOptionInfo.isLoading }">
                    Current Tier:
                    <span class="font-weight-600" v-if="!supplierTierOptionInfo.isLoading">{{
                        `${supplierTierOptionInfo.name}
                        (${supplierTierOptionInfo.percentage}% `}} <b class="plan-fee">fee</b>)</span>
                    <span class="font-weight-600" v-if="supplierTierOptionInfo.isLoading">Loading ...</span>
                </div>
            </div>
        </div>

        <subscriptionCard :subscriprionCards="subscriptionCardsValidated" :isLoading="isLoading"></subscriptionCard>

        <div class="division"></div>

        <div class="d-flex justify-content-between my-4">
            <div class="fs-super">Last update: <b class="bold">{{ formatDate(updateDate) }}</b></div>
            <button class="btn bg-dark" @click="openModelReport" v-if="isReportsAvailable">
                <span class="mr-3">Sales & Commissions Summary</span>
                <i class="fs-larger fas fa-download mr-0"></i>
            </button>
        </div>

        <div v-if="accountDetailsValidation">
            <accountDetails :accountDetails="accountDetailsInfo.salesDetails" :isLoading="isLoading" :type="0">
            </accountDetails>

            <accountDetails :accountDetails="accountDetailsInfo.accountDetails" :isLoading="isLoading" :type="1">
            </accountDetails>
        </div>

        <div v-else class="row d-flex flex-column pl-3 pb-4">
            <div class="row">
                <div class="col-6 pb-3" :class="{ 'opacity-50': isLoading }">
                    <div class="d-flex align-items-center card no-info">
                        <div class="d-flex flex-grow-1 flex-row justify-content-between align-items-center">
                            <span class="fs-large bold">No information available!</span>
                            <i class="fs-largest fas fa-exclamation-circle dark"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { supplierPlanMixin } from '@/mixins/supplierPlan.js'
import subscriptionCard from './myPlan/SubscriptionCard'
import accountDetails from './myPlan/AccountDetails'

export default {
    mixins: [
        supplierPlanMixin
    ],
    data() {
        return {
            isLoading: false,
            isProdActive: false,
            accountDetailsInfo: {
                salesDetails: {},
                accountDetails: {}
            },
        }
    },
    beforeMount() {
        this.downloadSupplierTierSummary();
        this.downloadTierOptions();
        this.donwloadSubscribedPlugins();
    },
    computed: {
        ...mapGetters([
            'getSupplierTierInfo',
            'getSupplierAllTiersOptionInfo',
            'getSubscribedPlugins',
            'getSubscriptionCards'
        ]),
        subscriptionCards() {
            return this.getSubscriptionCards;
        },
        subscriptionCardsValidated() {
            const subcribedPlugins = this.getSubscribedPlugins;

            return this.subscriptionCards.map(card => {
                card.isSubcriptionActive = subcribedPlugins.includes(card.codeName);
                
                return card;
            });
        },
        supplierTierOptionInfo() {
            if (this.getSupplierAllTiersOptionInfo !== null && this.getSupplierTierInfo !== null) {
                let currentTier;

                this.getSupplierAllTiersOptionInfo.filter((plan) => {
                    if (plan.name === this.getSupplierTierInfo.tier) {
                        currentTier = plan;
                    }
                })

                this.createAccountDetailsObj(this.getSupplierTierInfo)

                return currentTier;
            } else {
                return {
                    name: 'Loading ...',
                    percentAmount: 0,
                    isLoading: true
                }
            }
        },
        updateDate() {
            if (this.getSupplierTierInfo !== null) {
                return this.getSupplierTierInfo.lastDateProcessed;
            }
        },
        isReportsAvailable() {
            return false;
        },
        accountDetailsValidation() {
            return Object.keys(this.accountDetailsInfo.salesDetails).length !== 0 && Object.keys(this.accountDetailsInfo.accountDetails).length !== 0
        }
    },
    methods: {
        ...mapActions([
            'downloadSupplierTierSummary',
            'downloadTierOptions',
            'openModal',
            'donwloadSubscribedPlugins',
        ]),
        openModelReport() {
            this.openModal('PrintReport');
        },
        createAccountDetailsObj(data) {
            if (!data) {
                return;
            }

            const date = this.getDateDetails(data.lastProcessedDate);

            const details = {
                salesDetails: {
                    title: 'Sales Details',
                    subTitle: 'Accumulated monthly value',
                    date: date.month,
                    info: [
                        {
                            title: 'Processed reservations value',
                            value: data.currentMonthBookingValue,
                            valueType: 'cash'
                        },
                        {
                            title: 'Pluralo commission',
                            value: data.currentMonthPluraloCommission,
                            valueType: 'cash'
                        }
                    ]
                },
                accountDetails: {
                    title: 'Current Account',
                    subTitle: 'Accumulated annual value',
                    date: date.year,
                    info: [
                        {
                            title: 'Processed reservations value',
                            value: data.currentYearBookingValue,
                            valueType: 'cash'
                        },
                        {
                            title: 'Pluralo commission',
                            value: data.currentYearPluraloCommission,
                            valueType: 'cash'
                        }
                    ]
                }
            }

            this.accountDetailsInfo = details;
        },
        forceRefresh() {
            this.isLoading = true;
            this.downloadSupplierTierSummary().then(response => {
                this.isLoading = false
            }).catch(err => {
                this.isLoading = false
            })
        },
        getDateDetails(data) {
            const date = new Date(data)
            const month = date.toLocaleString('en-GB', { month: 'long' });
            const year = date.getFullYear();

            return { month, year };
        }
    },
    components: {
        subscriptionCard,
        accountDetails
    }
}
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/_variables.scss";

    .refreshIcon {
        cursor: pointer;

        &.loading {
            animation: rotation 2s infinite linear;

            @keyframes rotation {
                from {
                    -webkit-transform: rotate(0deg);
                }

                to {
                    -webkit-transform: rotate(359deg);
                }
            }
        }
    }

    .full-height {
        min-height: 77vh;
    }

    .plan-fee {
        font-size: 24px;
        padding-bottom: 5px;
    }

    .division {
        border-bottom: solid 1px #cecece;
        padding-left: 15px;
        padding-top: 30px;
    }

    .card {
        position: relative;
        min-height: 95px;
        max-width: 375px;
        padding: 20px;
        background: #FFFFFF;
        color: $darkest;
        box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
        border-radius: 5px;

        .textZone {
            padding-right: 5px;
        }

        &.no-info {
            width: 350px;
        }
    }
</style>



// WEBPACK FOOTER //
// TabPlan.vue?d664d500